module.exports = __webpack_public_path__ + "static/media/la-regular-400.2746742c.eot";